import React from 'react';
import { Typography, Box } from '@mui/material';

export const Profile: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        个人资料
      </Typography>
      <Typography variant="body1" color="text.secondary">
        个人资料管理功能正在开发中...
      </Typography>
    </Box>
  );
}; 